// Microsoft Teams placeholder app (ouvre comme base.js)
import React from 'react';
import { Paper, Typography, Button } from '@mui/material';

export default function TeamsApp() {
  const openTeamsWeb = () => {
    window.open("https://teams.microsoft.com/", "_blank", "noopener");
  };

  return (
    <Paper elevation={4} sx={{ p: 3, maxWidth: 320, margin: 'auto' }}>
      <Typography variant="h6" align="center" gutterBottom>
        Microsoft Teams
      </Typography>
      <Typography variant="body1" align="center" color="textSecondary" sx={{ mb: 2 }}>
        Teams ne peut pas être intégré directement dans Webdesk.<br/>
        Cliquez ci-dessous pour ouvrir Teams complet dans un nouvel onglet.
      </Typography>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={openTeamsWeb}
      >
        Ouvrir Teams (Web)
      </Button>
    </Paper>
  );
}
